import _Object$assign from 'babel-runtime/core-js/object/assign';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _extends from 'babel-runtime/helpers/extends';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

/* eslint-disable vue/no-mutating-props */
import { generateProduct } from '@/views/demand/utils/product';
import { curdDemandPageMixin } from '@/views/demand/mixin/demand';
import demandMixin from './demand-mixin';
import DemandForm from './form.vue';
import { getReviewInfo as _getReviewInfo } from '@/api/creative/review';
import _ from 'lodash';
import { fetchAdvertiserInfo } from '@/api/advertiser/manage';
import { cookDemand } from '../utils/cook-api-demand-info';
import { generateCreation } from '@/views/demand/utils/creation';
import { cookProducts } from './utils';
import { cookCreationList } from './utils';
import AdvertiserInfoDialog from '@/views/advertiser/dialog.vue';
import { format, addDays } from 'date-fns';

export default {
  components: {
    DemandForm: DemandForm,
    AdvertiserInfoDialog: AdvertiserInfoDialog
  },

  // data: demand/creationList/products; methods: getDemandDetail
  mixins: [curdDemandPageMixin, demandMixin],

  data: function data() {
    return {
      saveAdvertiserSubmitButton: {
        loading: false
      }
    };
  },


  computed: {
    id: function id() {
      return Number(this.$route.params.id || this.$route.query.copy_id);
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var similar_demands;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.products = [_extends({}, generateProduct(), {
                platform: 'ios' // 默认 ios
              })];

              // 存在 ID（编辑需求与复制需求） 就去获取数据

              if (!_this.id) {
                _context.next = 10;
                break;
              }

              _context.next = 4;
              return _this.getDemandDetail(_this.id);

            case 4:

              // 如果是拷贝需求，需要删除无用的数据
              if (_this.copyId) {
                _this.$nextTick(function () {
                  return _this.copyDemand();
                });
              }

              // 赋值adv_id之后，需要重新赋值广告主下拉组件
              _this.$refs['demand-form'].setAdvertiserSelectorOptions({
                label: _this.demand.adv_name,
                value: _this.demand.adv_id
              });
              similar_demands = [];

              if (_this.demand.similar_demands && _this.demand.similar_demands.length) {
                similar_demands = _this.demand.similar_demands;
                // 赋值adv_id之后，需要重新赋值广告主下拉组件
                _this.$refs['demand-form'].setDemandSelectorOptions(similar_demands.map(function (item) {
                  return {
                    label: item.name,
                    value: item.id
                  };
                }));
              }

              // 如果是复制需求，需要把复制需求的 id 赋值到参考需求中
              if (_this.copyId) {
                if (_this.demand.similar_demand_ids.indexOf(_this.id) === -1) {
                  similar_demands.push({
                    name: _this.demand.name,
                    id: _this.id
                  });
                  _this.$refs['demand-form'].setDemandSelectorOptions(similar_demands.map(function (item) {
                    return {
                      label: item.name,
                      value: item.id
                    };
                  }));
                  _this.demand.similar_demand_ids.push(_this.id);
                }
              }

              return _context.abrupt('return');

            case 10:
              if (!_this.reviewId) {
                _context.next = 14;
                break;
              }

              console.log('填写审核内容');
              _context.next = 14;
              return _this.getReviewInfo(_this.reviewId);

            case 14:

              // 首次创建的时候，如果是运营角色，则直接赋值到需求AM中去, 存在审核 id，则使用审核的 pm 作为 AM 角色
              if (!_this.reviewId && _this.$store.getters.userInfo.role_types && _this.$store.getters.userInfo.role_types.indexOf(4) !== -1) {
                _this.demand.account_manager_id = _this.$store.getters.user_id;
              }

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    copyDemand: function copyDemand() {
      this.demand.copy_id = this.id;
      // 清空创意参考资料，因为服务端只接收portal://开头的创意参考链接
      // 但是这个链接是 S3 链接，是无法正常提交的，所以复制需求时，必须重新上传
      this.demand.reference_url = '';
      this.demand.reference_name = '';
      // 清空期望交付日期
      this.demand.expect_time = '';
      // 清空是否sk
      this.demand.key_account = '';
      // 如果是设计项目，则清空，反之则选否
      this.demand.is_pay = this.isDesign ? '' : 2;
      // 清空
      // 不需要状态
      delete this.demand.status;
      // products 的 id 不需要
      this.products = this.products.map(function (item) {
        delete item.id;
        return item;
      });
      // creationList 的 id 不需要， 且如果是拷贝需求，则删除MTG和DSP渠道
      this.creationList = this.creationList.map(function (item) {
        delete item.id;
        item.channel = Array.isArray(item.channel) ? item.channel.filter(function (i) {
          return i !== 1 && i !== 2;
        }) : item.channel;
        return item;
      });
      // 赋值 channel_setting 配置
      // if (this.demand.channel_setting) {
      //   const channelSetting = JSONParse(this.demand.channel_setting)
      //   if (channelSetting) {
      //     this.demand.content_rating = channelSetting.content_rating
      //     this.demand.ir_report_point = channelSetting.ir_report_point
      //     this.demand.ir_creative_genre = channelSetting.ir_creative_genre
      //   }
      // }
    },
    getReviewInfo: function getReviewInfo(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, review, ext_info, creative_name, offer_uuid, creative_link, local_creative_link, adv_name, pm_id, extInfo, app_name, bgm_url, language, market_url, platform, cookDemandName, cookInstruction, cookInteractiveType, demand, cookOfferUuid;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;

                _context2.prev = 1;
                _context2.next = 4;
                return _getReviewInfo(id);

              case 4:
                res = _context2.sent;
                review = _.get(res, 'data.data.info') || {};

                if (!_.isEmpty(review)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt('return');

              case 8:
                ext_info = review.ext_info, creative_name = review.creative_name, offer_uuid = review.offer_uuid, creative_link = review.creative_link, local_creative_link = review.local_creative_link, adv_name = review.adv_name, pm_id = review.pm_id;
                extInfo = JSON.parse(ext_info);
                app_name = extInfo.app_name, bgm_url = extInfo.bgm_url, language = extInfo.language, market_url = extInfo.market_url, platform = extInfo.platform;

                cookDemandName = function cookDemandName() {
                  // 相关素材
                  var related = _.get(res, 'data.data.related') || [];
                  related.push({
                    app_name: app_name,
                    creative_name: creative_name,
                    offer_uuid: offer_uuid
                  });
                  var creativeName = _.uniq(related.map(function (item) {
                    return item.creative_name;
                  })).join();
                  var appName = _.uniq(related.map(function (item) {
                    return item.app_name;
                  })).join();
                  return 'SS pl\u5BA1\u6838-[' + creativeName + ']-[' + appName + ']-' + platform + '-[' + language + ']-Mintegral';
                };

                cookInstruction = function cookInstruction() {
                  return 'Pl\u539F\u59CB\u7D20\u6750\u5730\u5740\uFF1A' + creative_link + (bgm_url ? '\n背景音乐地址：' + bgm_url : '') + (local_creative_link ? '\n系统自动加背景音乐地址：' + local_creative_link : '');
                };

                cookInteractiveType = function cookInteractiveType() {
                  /**
                   * creative_type
                   * 3:playable 2d
                   * 4:playable 3d
                   * 5:动态endcard
                   * 6:interactive video
                   * 7:panoramic
                   */
                  if (review.creative_type === 3 || review.creative_type === 4 || review.creative_type === 6) {
                    return 1;
                  }
                  if (review.creative_type === 5 || review.creative_type === 7) {
                    return 2;
                  }
                };

                _context2.t0 = _;
                _context2.next = 17;
                return fetchAdvertiserInfo({ name: adv_name });

              case 17:
                _context2.t1 = _context2.sent;
                _context2.t2 = _context2.t0.get.call(_context2.t0, _context2.t1, 'data.data.info.id');
                _context2.t3 = adv_name;
                _context2.t4 = cookDemandName();
                _context2.t5 = cookInstruction();
                _context2.t6 = cookInteractiveType();
                _context2.t7 = format(addDays(new Date(), 1), 'YYYY-MM-DD');
                _context2.t8 = platform;
                demand = {
                  adv_id: _context2.t2,
                  adv_name: _context2.t3,
                  name: _context2.t4,
                  instruction: _context2.t5,
                  interactive_type: _context2.t6,
                  is_advertiser_review: 2,
                  category: 'mintegral',
                  key_account: 3,
                  expect_time: _context2.t7,
                  id: '',
                  material_source: 3,
                  type: 1,
                  platforms: _context2.t8
                };

                !!pm_id && (demand.account_manager_id = String(pm_id));

                _this2.demand = _Object$assign({}, _this2.demand, cookDemand({ demand: demand }));

                // 赋值adv_id之后，需要重新赋值广告主下拉组件
                _this2.$refs['demand-form'].setAdvertiserSelectorOptions({
                  label: _this2.demand.adv_name,
                  value: _this2.demand.adv_id
                });

                cookOfferUuid = function cookOfferUuid() {
                  var related = _.get(res, 'data.data.related') || [];
                  related.push({
                    app_name: app_name,
                    creative_name: creative_name,
                    offer_uuid: offer_uuid
                  });
                  return _.uniq(related.map(function (item) {
                    return item.offer_uuid;
                  })).join();
                };

                if (extInfo) {
                  console.log(extInfo);
                  // 延迟赋值，因为 platform 赋值之后，会重置 product 的值
                  // 如果不做延迟，Vue 会将两次变动合并为一次，导致展示不正确
                  _this2.$nextTick(function () {
                    _this2.products = cookProducts([_extends({}, extInfo, {
                      app_url: market_url,
                      app_name: app_name,
                      creative_name: creative_name,
                      offer_uuid: cookOfferUuid()
                    })], _this2.demand);
                    // 编辑与复制需求时，在读取到 products 并赋值，product-info 组件监听 product.app_url 无法被触发，所以暴露一个事件出去
                    _this2.$nextTick(function () {
                      _this2.$root.$emit('demand:get-app-info');
                    });
                  });

                  _this2.$nextTick(function () {
                    _this2.creationList = cookCreationList([{
                      channel_ids: '21', // 默认勾选 mintegral
                      languages: language
                    }], _this2.demand);
                    _this2.$nextTick(function () {
                      _this2.$root.$emit('demand:get-creation-size');
                    });
                  });
                }

                _this2.loading = false;
                _context2.next = 38;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t9 = _context2['catch'](1);

                _this2.loading = false;
                _this2.$message.error('\u83B7\u53D6\u8BE6\u60C5\u5931\u8D25' + _context2.t9.message);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 34]]);
      }))();
    },
    updateDemand: function updateDemand(demand) {
      this.demand = demand;
    },
    updateProducts: function updateProducts(products) {
      this.products = products;
    },
    emptyCreationList: function emptyCreationList() {
      this.creationList = [generateCreation()];
    },
    updateCreationList: function updateCreationList(list) {
      this.creationList = list;
    }
  }
};